const breakpoints = require('../../services/breakpoints'),
	querystring = require('../../utils/querystring');

let pageTargeting;

function init(settings) {
	pageTargeting = _getSafeTargeting(settings.targeting);
	_updatePageTargeting();
}

function _updatePageTargeting() {
	const adops = querystring.get('adops');

	if (adops) {
		pageTargeting.adops = adops;
	}

	pageTargeting.screen = breakpoints.getCurrentBreakpoint();
}

function getPageTargeting() {
	_updatePageTargeting();

	return _replacePlaceholders(_getSafeTargeting(pageTargeting));
}

function getSlotTargeting(/** Slot */ slot) {
	return _replacePlaceholders(_getSafeTargeting(slot.targeting), slot);
}

function _getSafeTargeting(targeting) {
	return Object.keys(targeting).reduce((t, key) => {
		let value = _getSafeTargetValue(key, targeting[key]);

		if (value !== null) {
			t[key] = value;
		}

		return t;
	}, {});
}

function _getSafeTargetValue(key, value) {
	if (typeof value === 'string') {
		return value;
	}

	if (typeof value === 'boolean' || typeof value === 'number') {
		return value.toString();
	}

	if (Array.isArray(value)) {
		return value.map((val, idx) => {
			if (Array.isArray(val)) {
				return null;
			}

			return _getSafeTargetValue(`${key}.${idx}`, val);
		}).filter((val) => val !== null);
	}

	return null;
}

function _replacePlaceholders(targeting, slot) {
	Object.keys(targeting).forEach((field) => {
		if (typeof targeting[field] === 'string') {
			targeting[field] = targeting[field].replace('%screenSize%', breakpoints.getCurrentBreakpoint());

			if (slot) {
				targeting[field] = targeting[field].replace('%slotName%', slot.name);
			}
		}
	});

	return targeting;
}

module.exports = {
	init,
	getPageTargeting,
	getSlotTargeting
};
